import HandshakeIcon from "@mui/icons-material/Handshake";
import SearchIcon from "@mui/icons-material/Search";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import GppGoodIcon from "@mui/icons-material/GppGood";
import PsychologyIcon from "@mui/icons-material/Psychology";
import LaptopChromebookIcon from "@mui/icons-material/LaptopChromebook";

export const locationsTab = [
  {
    id: 1,
    value: "1",
    label: "Accompagnement",
    icon: <HandshakeIcon size={24} />,
  },
  { id: 2, value: "2", label: "Audit", icon: <SearchIcon size={24} /> },
  {
    id: 3,
    value: "3",
    label: "Formation",
    icon: <ContentPasteSearchIcon size={24} />,
  },
  {
    id: 4,
    value: "4",
    label: "Solutions IT",
    icon: <LaptopChromebookIcon size={24} />,
  },
  {
    id: 5,
    value: "5",
    label: "Ingénierie",
    icon: <PsychologyIcon size={24} />,
  },
];
